import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { Doc } from '/imports/types';
import { MILLIS_1_MIN } from '/imports/constants';

export interface RealtimeUpdate extends Doc {
  docId?: string;
  type?: string;
  message: string;
  startTime: Date;
}

export const RealtimeUpdates = new Mongo.Collection<RealtimeUpdate>('realtimeUpdates');

/**
 * Clears any prior updates for the doc/type and inserts a new realtime update that auto-expires.
 * @param arg - update fields plus optional _id and expiry timeout (ms; default 30 min)
 * @returns the inserted update's id
 */
export const realtimeUpdateInit = async (arg: { _id?: string, docId?: string, type?: string, message?: string, timeout?: number }) => {
  const { docId, type, message, timeout } = arg;
  if (docId && type) await RealtimeUpdates.removeAsync({ docId, type });
  else if (docId) await RealtimeUpdates.removeAsync({ docId });
  const rtu: any = { docId, type, message, startTime: new Date() };
  if (arg._id) rtu._id = arg._id;
  const _id = RealtimeUpdates.insertAsync(rtu);
  setTimeout(() => RealtimeUpdates.removeAsync(_id), timeout || 30 * MILLIS_1_MIN);
  return _id;
};

/**
 * Updates an existing realtime update's message and type.
 * @param arg - the update id (rtid), new message, and optional type
 * @returns the update result
 */
export const realtimeUpdateSet = async (arg: { rtid: string, message: string, type?: string }) => {
  const { rtid, message, type } = arg;
  return RealtimeUpdates.updateAsync(rtid, { $set: { message, type } });
};

/**
 * Removes a realtime update.
 * @param rtid - the update id
 * @returns the removal result
 */
export const realtimeUpdateDone = async (rtid: string) => {
  return RealtimeUpdates.removeAsync(rtid);
};

if (Meteor.isServer) {
  RealtimeUpdates.createIndex({ startTime: 1 });
  RealtimeUpdates.createIndex({ docId: 1 }, { sparse: true });
  RealtimeUpdates.createIndex({ type: 1 }, { sparse: true });
}

Meteor.startup(() => {
  if (Meteor.isServer) RealtimeUpdates.removeAsync({});
});